import { reactive } from 'vue';

export { TooltipControllerSingleton as default };

/**
* Defines all layout settings to be used by the application
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class TooltipController {
  /**
   * Tooltip Text
   *
   * @param {string}
   *
   * @public
   *
   * @since 7.0.0
   */
  text;

  /**
   * Prefered tooltip position
   *
   * @param {string}
   *
   * @public
   *
   * @since 7.0.0
   */
  position;

  /**
   * Defines if tooltip should be displayed
   *
   * @param {string}
   *
   * @public
   *
   * @since 7.0.0
   */
  display = false;

  /**
   * Tooltip HTML Target Element
   *
   * @param {Object}
   *
   * @public
   *
   * @since 7.0.0
   */
  target;
}

const TooltipControllerSingleton = reactive(new TooltipController());